var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{staticClass:"sign-image",class:{ 'hover-on-load': _vm.hoveredOnLoad },attrs:{"src":require("../../public/img/sign.png"),"alt":"Sign Image"}}),_c('p',{staticClass:"below-text"},[_vm._v("Please select an agent number")])])
}
var staticRenderFns = []

export { render, staticRenderFns }